import Text from '@components/Text';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useOnIdentifySuccess from './hooks/useOnIdentifySuccess';

interface Params {
    refreshToken: string;
}

const IdentifySuccessActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { refreshToken } = params;
  useOnIdentifySuccess(refreshToken);
  return (
      <AppScreen>
          <Text></Text>
      </AppScreen>
  );
};

export default IdentifySuccessActivity;
